import type { RegistrationData } from '@/types/registration';
import { wregStepIsAccessible } from '@/components/webreg/wregGates';
import { wregHasShipped } from '@/components/webreg/wregFlowState';
import type { WregStep } from '@/components/webreg/wregSteps';

// Furthest-first, and deliberately without `tracks`/`agreement`: their gates are dev-panel-only,
// so a member must never be resumed onto one. `intake` is not listed either — its gate is
// unconditionally true, so it is the fallthrough rather than a candidate.
export const WREG_RESUME_ORDER: readonly WregStep[] = [
  'allset',
  'monitor',
  'switch',
  'labs',
  'screener',
  'intake-mbi',
  'intake-about',
  'intake-contact',
];

export const wregHasProgress = (data: RegistrationData): boolean => {
  const { medicareCoverage: m, account: a, wreg } = data;
  return (
    m.firstName !== '' ||
    m.lastName !== '' ||
    m.dateOfBirth !== '' ||
    m.mbi !== '' ||
    a.email !== '' ||
    a.phoneNumber !== '' ||
    wreg.eligCode !== null ||
    wreg.alignCode !== null ||
    wreg.exit !== null ||
    data.selectedTracks.length > 0 ||
    data.labsCompleted !== null ||
    wregHasShipped(data)
  );
};

export const wregResumeStep = (data: RegistrationData): WregStep => {
  if (data.wreg.exit !== null) return data.wreg.exit;
  const ctx = { data, devEnabled: false };
  for (const step of WREG_RESUME_ORDER) {
    // `switch` sits ahead of `labs` so an owed attestation is not skipped, but its gate does not
    // read the attestation itself, so a member who already attested would be sent back to it.
    if (step === 'switch' && data.wreg.switchAttested) continue;
    if (wregStepIsAccessible(step, ctx)) return step;
  }
  return 'intake';
};
